export enum UploadMode {
  CONSECUTIVE,
  INCONSECUTIVE,
}
